export const content = "No, we don\u2019t offer letters for educational or workplace accommodations. We suggest reaching out to a primary care physician (PCP) for further guidance.\n";
